export default __webpack_public_path__ + "static/media/note-taker.34b50957.png";